import { prefixObjectValues as pre } from '../utils';

const prefix = 'employment-table';

const table = pre(
  {
    grid: 'employer-grid',
    employerName: 'employer-name-',
    employerAddress: 'employer-address-',
    date: 'education-dates-',
    position: 'education-position-',
    department: 'education-department-',
    current: 'education-current-',
    currentRow: 'education-current-row',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
